import { BASE_URL } from "../constants/Constants";
import axiosInstance from "./axiosInstance";

export const getAllViewTypes = async () => {
    try {
        const response = await axiosInstance.get(`${BASE_URL}/viewType`);
        return response.data;
    } catch (error) {
        console.error('Error fetching viewTypes:', error);
        return error.response.data;
        //throw error;
    }
};